export default theme => ({
    root: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.up("xs")]: {
        backgroundColor: theme.palette.common.white
      },
      [theme.breakpoints.down("md")]: {
        backgroundColor: "rgba(255,255,255,0.8)"
      }
    },
    marginContainer:{
      marginTop:'-55pt',
      position:'relative',
      backgroundColor:'white',    
      zIndex:'2',
      maxWidth:'720px',
    },
  
    productsPage: {
      [theme.breakpoints.only("xs")]: {
        padding: theme.typography.pxToRem(32 * 2),
        paddingTop: theme.typography.pxToRem(16 * 2)
      },
      [theme.breakpoints.down("xs")]: {
        padding: theme.typography.pxToRem(8 * 2),      
        height:670
      },
      [theme.breakpoints.between("xs","md")]: {
        height: '720px',
        width: 'auto',
        padding: theme.typography.pxToRem(16 * 2),
      },
      [theme.breakpoints.up("lg")]: {
        height: 780, 
        width: 720 
      },
      borderRadius: '30pt',    
    },
    
    inputSpacing:{
      marginBottom: "20px",
      paddingLeft: "45px",
      [theme.breakpoints.down("md")]: {
        paddingLeft: "15px",
      },
    },
    wrappedForm: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        backgroundColor: theme.palette.common.white,
      },
     [theme.breakpoints.up("xs")]: {
        width: 445
      }, 
      height: "100%",
      [theme.breakpoints.up("lg")]: {
        backgroundColor: theme.palette.common.white
      }
    }
    
  });
  